export default {
  state: {
    isSubmitInProgress: false,
    email: '',
    description: ''
  },
  getters: {
    isSubmitInProgress(state) {
      return state.isSubmitInProgress;
    }
  },
  mutations: {
    setFormData(state, { email, description }) {
      state.email = email
      state.description = description
    },
    setIsSubmitInProgress(state, isInProgress) {
      state.isSubmitInProgress = isInProgress
    }
  },
  actions: {
    submitForm(context, payload) {
      context.commit('setIsSubmitInProgress', true)
      context.commit('setFormData', payload)
      setTimeout(() => {
        context.commit('setIsSubmitInProgress', false)
      }, 2000)
    }
  }
}
